var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bundle-products"},_vm._l((_vm.filteredBundles),function(bundle){return _c('BundleProductCard',{key:("" + (bundle.uid)),attrs:{"bundle":bundle}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }